import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { logOut, updateLocalStorageToken } from '../../../../../containers/resources/utils';

export const customYachtItineraryList = createSlice({
  name: 'customYachtItineraryList',
  initialState: {
    itinerary: {},
    yachtItineraries: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateYachtItineraryListCustom(state, action) {
      return {
        itinerary: {},
        yachtItineraries: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesYachtItineraryListCustom(state, action) {
      return {
        itinerary: {},
        yachtItineraries: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchYachtItineraryListCustomSuccess(state, action) {
      return {
        itinerary: action.payload.itinerary,
        yachtItineraries: action.payload.yachtItineraries,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchYachtItineraryListCustomError(state, action) {
      return {
        itinerary: {},
        yachtItineraries: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload.message,
      }
    }
  }
})

export const fetchYachtItineraryListCustom = (itinerary_id) => dispatch => {
  dispatch(requesYachtItineraryListCustom());
  axios.get(`/itinerary/${itinerary_id}/yachtItineraryList`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchYachtItineraryListCustomSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchYachtItineraryListCustom(itinerary_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchYachtItineraryListCustomError(json.data.data));
      }
    })
};

export const {
  initialStateYachtItineraryListCustom,
  requesYachtItineraryListCustom,
  fetchYachtItineraryListCustomSuccess,
  fetchYachtItineraryListCustomError,
} = customYachtItineraryList.actions;

export default customYachtItineraryList.reducer;